import { useEffect, useState } from "react";
import Faq from "@/components/faq";
import { sanityClient } from "@/sanity/lib/client";
import Button from "@/components/Button";
import styles from "./styles.module.scss"

export function FAQs({ title, faqCategory, faqs }) {
  const [categoryFaqs, setCategoryFaqs] = useState([]);

  useEffect(() => {
    if (!faqs?.length && faqCategory?._id) {
      sanityClient
        .fetch(
          `*[_type == "faq" && references($categoryId)] | order(orderRank)`,
          { categoryId: faqCategory._id }
        )
        .then(setCategoryFaqs);
    }
  }, [faqCategory, faqs]);

  const resolvedFaqs = faqs?.length ? faqs : categoryFaqs;

  if (!resolvedFaqs.length) return null;

  return (
  <section className={styles.section}>
    <Faq title={title} faqs={resolvedFaqs} />
    <Button type="link" href="/faq" className="primary">View All FAQs</Button>
  </section>
  )
}